import {connect} from 'react-redux';
import {reduxForm} from 'redux-form';
import {ff, form} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
const {Form, FormBody, FormActions} = form;
import CustomCheckboxField from "../components/CustomCheckboxField";
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Formulář pro tvorbu/úpravu termínu dopravy.
 */
class DopravaTerminForm extends Component<WithTranslation> {

    static formName = 'DopravaTerminForm';

    static validate = (values, props) => {
        const {t} = props;
        const errors = {};
        if (!values.nazevTermin) {
            errors.nazevTermin = t('validation.name_required');
        }
        if (!values.rozhodnyPocetMinut) {
            errors.rozhodnyPocetMinut = t('validation.name_required');
        }
        return errors;
    };

    render() {
        const {onClose, submitting, handleSubmit, t} = this.props;
        return <Form onSubmit={handleSubmit} horizontal>
            <FormBody>
                <ff.String label={t('labels.name')} name="nazevTermin" required disabled={submitting} />
                <ff.Time label={t('labels.delivery_time_from')} name="casDoruceniOd" disabled={submitting} />
                <ff.Time label={t('labels.deliver_date_to')} name="casDoruceniDo" disabled={submitting} />
                <ff.Number label={t('labels.decisive_minutes')} name="rozhodnyPocetMinut" disabled={submitting} required />
                <CustomCheckboxField label={t('labels.inactive')} name="neaktivni" disabled={submitting}/>
            </FormBody>
            <FormActions onClose={onClose} storeButton={t('save')} cancelButton={t('buttons.cancel')} disabled={submitting} />
        </Form>
    }
}

export default withTranslation()(connect()(reduxForm({
    form: DopravaTerminForm.formName,
    validate: DopravaTerminForm.validate,
})(DopravaTerminForm)));
